import { render } from "./VotingHistory.vue?vue&type=template&id=0870d5ce&scoped=true"
import script from "./VotingHistory.vue?vue&type=script&lang=js"
export * from "./VotingHistory.vue?vue&type=script&lang=js"

import "./VotingHistory.vue?vue&type=style&index=0&id=0870d5ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0870d5ce"]])

export default __exports__